import { render, staticRenderFns } from "./HomesList.vue?vue&type=template&id=2d4331ca&scoped=true"
import script from "./HomesList.vue?vue&type=script&lang=js"
export * from "./HomesList.vue?vue&type=script&lang=js"
import style0 from "./HomesList.vue?vue&type=style&index=0&id=2d4331ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4331ca",
  null
  
)

export default component.exports